import { RootState } from 'app/store/rootReducer';

export const getReferral = (state: RootState) => state.referral;
